<script>
import con from '@services/connection'
import { simulador } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import { mask } from 'vue-the-mask'
import Vue from 'vue'
import store from '@state/store'
import { toPercent, getNumber, toMoney, formatNumber } from '@utils/Format'
import { VMoney } from 'v-money'
import { Money, Percent, Neutral } from '@constants/Masks'
import { MODAL, CLASSES_SIMULADOR, RATINGS } from '@constants/Text'
import ClientTags from '@modules/crm/components/client-tags/client-tags.vue'
import { RECOMENDACAO_OPTIONS } from '@modules/consolidator/constants/recomendacao'

export default {
  components: {
    Title,
    ClientTags,
  },
  directives: {
    mask,
    money: VMoney,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
    plTotal: {
      type: Number,
      default: 0.0,
    },
    plNaoAlocado: {
      type: Number,
      default: null,
    },
    plSugerido: {
      type: Number,
      default: 0,
    },
    ativosAtuais: {
      type: Array,
      default: () => null,
    },
    janelaTempo: {
      type: Number,
      default: 6,
    },
    classes: {
      type: Array,
      default: () => {
        return []
      },
    },
    qualificado: Boolean,
    ativosSelecionados: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    return {
      toPercent,
      getNumber,
      rules: rules,
      RATINGS: RATINGS,
      masks: {
        cnpj: '##.###.###/####-##',
      },
      maskData: '##/##/####',
      maskMoney: Money,
      maskPercent: Percent,
      maskNeutral: Neutral,
      busModal: new Vue(),
      loading: false,
      show: true,
      master: false,
      ativo: {
        nome_ativo: 'Ativo',
        pl: '',
        percentual: '',
        modo: 'R$',
        subclasse: '',
        classe: '',
        setor: '',
        recomendacao: null,
        comentario: '',
        tags: [],
      },
      openClass: false,
      classes_simulador: CLASSES_SIMULADOR,
      valor: '',
      mode: 'R$',
      callback: null,
      modo_unico_ativos: '',
      loading_info: false,
      infoAtivo: {},
      has_asset: false,
      infoClient: {},
      showSubclass: false,
      hideAlerts: false,
      recomendacaoOptions: RECOMENDACAO_OPTIONS,
    }
  },
  computed: {
    subclasses() {
      return this.$store.getters['subclasse/listagem'].filter((item) => {
        return item.classe === this.ativo.classe
      })
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    aplMin() {
      if (this.ativo.tipo === 'RF') {
        return this.ativo.quantidade_minima * this.ativo.pu
      }
      return this.ativo.aplicacao_min
    },
    showAlets() {
      return (
        this.alertAplMin ||
        this.alertSaldoPerm ||
        this.alertJanelaTempo ||
        this.alertQualificado
      )
    },
    alertAplMin() {
      return (
        !this.has_asset &&
        getNumber(this.valor) &&
        this.aplMin > getNumber(this.valor) &&
        this.mode === 'R$'
      )
    },
    alertSaldoPerm() {
      return (
        this.has_asset &&
        getNumber(this.valor) &&
        this.ativo.saldo_permanencia > getNumber(this.valor) &&
        this.mode === 'R$'
      )
    },
    alertJanelaTempo() {
      return (
        this.infoAtivo.numero_meses &&
        (this.janelaTempo || 6) > this.infoAtivo.numero_meses
      )
    },
    alertQualificado() {
      return !this.has_asset && this.ativo.qualificado && !this.qualificado
    },
    actualClass() {
      if (this.classes.length) {
        let classData = this.classes.find((classItem) => {
          return (
            classItem.name === this.ativo.classe ||
            classItem.nome === this.ativo.subclasse
          )
        })
        classData = { ...classData }
        if (this.ativo.percentual) {
          classData.alocado -= getNumber(this.ativo.percentual)
        }
        if (classData) {
          if (this.ativosSelecionados && this.ativosSelecionados.length) {
            this.ativosSelecionados.forEach((assetItem) => {
              if (this.showSubclass) {
                if (classData.nome === assetItem.subclasse) {
                  classData.alocado += getNumber(assetItem.percentual)
                }
              } else {
                if (classData.name === assetItem.classe) {
                  classData.alocado += getNumber(assetItem.percentual)
                }
              }
            })
          }
          return classData
        }
      }
      return {}
    },
    plLivre() {
      return this.plNaoAlocado + getNumber(this.ativo.pl)
    },
  },
  created() {
    this.bus.$on(MODAL.SIMULATOR_EDIT_ASSET, this.open)
  },
  beforeDestroy() {
    this.bus.$off(MODAL.SIMULATOR_EDIT_ASSET, this.open)
  },
  methods: {
    open(asset, opts) {
      this.show = false

      this.ativo = this.normalizeAsset(asset)

      this.resetOpenState()
      this.applyOpenOptions(opts)

      this.mode = this.ativo.modo

      if (!this.hideAlerts) {
        this.getInfoAsset()
      }

      this.setHasAsset()
      this.initializeValor()

      this.busModal.$emit('dialog', true)
      this.show = true
    },
    normalizeAsset(asset) {
      const activeAsset = { ...(asset || {}) }

      const masterValue = activeAsset.master || ''
      const commentValue =
        typeof activeAsset.comentario === 'string' ? activeAsset.comentario : ''
      const tagsValue = Array.isArray(activeAsset.tags)
        ? [...activeAsset.tags]
        : []
      const setorValue =
        typeof activeAsset.setor === 'string' ? activeAsset.setor : ''
      const recomendacaoValue = activeAsset.recomendacao || null
      const modeValue = activeAsset.modo || 'R$'

      return {
        ...activeAsset,
        master: masterValue,
        setor: setorValue,
        recomendacao: recomendacaoValue,
        comentario: commentValue,
        tags: tagsValue,
        modo: modeValue,
      }
    },
    resetOpenState() {
      this.modo_unico_ativos = ''
      this.infoAtivo = {}
      this.infoClient = {}
      this.master = false
      this.showSubclass = false
      this.hideAlerts = false
    },
    applyOpenOptions(opts) {
      if (!opts) {
        return
      }

      this.openClass = !!opts.openClass
      this.callback = opts.callback

      if (opts.modo) {
        this.modo_unico_ativos = opts.modo
        this.ativo.modo = this.modo_unico_ativos
      }

      this.showSubclass = !!opts.showSubclass
      this.hideAlerts = opts.hideAlerts
    },
    initializeValor() {
      if (this.ativo.modo === 'R$') {
        this.valor = getNumber(
          this.ativo.pl ? this.ativo.pl.replace('R$', '') : '0,00'
        )

        if (this.plSugerido) {
          this.valor = this.plSugerido * 100
        } else {
          this.valor = getNumber(this.valor || 0)
        }

        return
      }

      if (this.ativo.modo === '%') {
        if (typeof this.ativo.percentual === 'number') {
          this.valor = getNumber(formatNumber(this.ativo.percentual, 2))
        } else {
          this.valor = getNumber(
            this.ativo.percentual && this.ativo.percentual.replace
              ? this.ativo.percentual.replace('%', '')
              : '0,00'
          )
        }
      }
    },
    toMoney(value) {
      return toMoney(value)
    },
    setHasAsset() {
      if (this.ativosAtuais && this.ativosAtuais.find) {
        const asset = this.ativosAtuais.find((currentAsset) => {
          return currentAsset.nome_ativo === this.ativo.nome_ativo
        })

        this.has_asset = !!asset
      } else {
        this.has_asset = false
      }
    },
    updateValueField() {
      if (
        this.$refs['edit-valor'] &&
        this.$refs['edit-valor'].$el.getElementsByTagName('input').length
      ) {
        Array.from(
          this.$refs['edit-valor'].$el.getElementsByTagName('input')
        ).forEach((inputElement) => {
          inputElement.value = this.valor
          inputElement.dispatchEvent(new Event('input'))
        })
      }
    },
    getActualAssetPercent() {
      return getNumber(this.ativo.percentual)
    },
    getActualAssetPl() {
      return getNumber(this.ativo.pl)
    },
    adjustByClass() {
      const classDifference =
        this.actualClass.percent - this.actualClass.alocado
      if (this.mode === 'R$') {
        const value = this.plTotal * (classDifference / 100)
        this.valor = formatNumber(value)
      }
      if (this.mode === '%') {
        this.valor = formatNumber(classDifference)
      }
      this.updateValueField()
    },
    adjustByGeneral() {
      const generalDifference = this.plLivre / this.plTotal
      if (this.mode === 'R$') {
        const value = this.plTotal * generalDifference
        this.valor = formatNumber(value)
      }
      if (this.mode === '%') {
        this.valor = formatNumber(generalDifference * 100)
      }
      this.updateValueField()
    },
    async getInfoAsset() {
      if (this.loading_info) {
        return
      }

      this.loading_info = true

      const response = await con.get(
        simulador.number_of_quotes +
          (this.ativo.referencia || this.ativo.nome_ativo)
      )

      if (response.status === 200) {
        this.infoAtivo = response.value
      } else {
        this.infoAtivo = {}
      }

      this.loading_info = false
    },
    async enviar() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.ativo.modo = this.mode

      if (this.ativo.modo === 'R$') {
        this.ativo.pl = toMoney(getNumber(this.valor))
        this.ativo.percentual = this.plTotal
          ? toPercent((getNumber(this.valor) / getNumber(this.plTotal)) * 100)
          : '0,00 %'
      }

      if (this.ativo.modo === '%') {
        this.ativo.percentual = toPercent(this.valor)
        this.ativo.pl = this.plTotal
          ? toMoney((getNumber(this.valor) / 100) * getNumber(this.plTotal))
          : 'R$ 0,00'
      }

      if (this.master) {
        this.ativo.CNPJ = this.ativo.master
      }

      if (this.callback) {
        this.callback(this.ativo)
      }
      this.busModal.$emit('dialog', false)
    },
    handleAddTag(newTag) {
      const tag = (newTag || '').trim()
      if (!tag) {
        return
      }

      if (!Array.isArray(this.ativo.tags)) {
        this.$set(this.ativo, 'tags', [])
      }

      if (!this.ativo.tags.includes(tag)) {
        this.ativo.tags.push(tag)
      }
    },
    handleRemoveTag(tagToRemove) {
      if (!Array.isArray(this.ativo.tags)) {
        return
      }

      this.ativo.tags = this.ativo.tags.filter((tag) => tag !== tagToRemove)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" persistent>
    <Title title="Editar ativo" />
    <v-form ref="form">
      <div class="row simulador-editar-ativo">
        <div class="col-12 pb-0">
          <v-text-field
            v-model="ativo.nome_ativo"
            label="Ativo"
            disabled
            :loading="loading_info"
          />
        </div>
        <div
          v-if="['Fundos', 'RF'].includes(ativo.tipo) && !hideAlerts"
          class="col-12 row pt-0"
        >
          <div class="col-6 py-0">
            <small class="text-secondary">
              Aplic. Mínima: {{ toMoney(aplMin) }}
            </small>
          </div>
          <div v-if="ativo.tipo === 'Fundos'" class="col-6 py-0">
            <small class="text-secondary">
              Saldo de Perm.: {{ toMoney(ativo.saldo_permanencia) }}
            </small>
          </div>
          <div class="col-6 py-0">
            <small class="text-secondary">
              Janela de tempo:
              {{
                infoAtivo.numero_meses ? infoAtivo.numero_meses + ' meses' : '-'
              }}
            </small>
          </div>
          <div class="col-6 py-0">
            <small class="text-secondary">
              Qualificado: {{ ativo.qualificado ? 'Sim' : 'Não' }}
            </small>
          </div>
        </div>
        <div
          v-if="ativo.referencia && ativo.tipo === 'Fundos' && !hideAlerts"
          class="col-4"
        >
          <v-text-field v-model="ativo.referencia" label="CNPJ" disabled />
        </div>
        <div v-if="ativo.tipo === 'Fundos' && !hideAlerts" class="col-3">
          <v-checkbox v-model="master" label="Usar master" />
        </div>
        <div v-if="master && !hideAlerts" class="col-5">
          <v-text-field
            v-model="ativo.master"
            v-mask="['##.###.###/####-##']"
            label="CNPJ master*"
            :rules="[rules.required, rules.cnpj]"
          />
        </div>
        <div v-if="openClass" class="col-6">
          <v-text-field
            v-model="ativo.classe"
            label="Classe*"
            required
            :rules="[rules.required]"
          />
        </div>
        <div v-if="!openClass" class="col-6">
          <v-select
            v-model="ativo.classe"
            label="Classe"
            :items="classes_simulador"
          />
        </div>
        <div v-if="showSubclass" class="col-6">
          <v-select
            v-model="ativo.subclasse"
            label="Subclasse"
            :items="subclasses"
            item-text="subclasse"
            item-value="subclasse"
          />
        </div>
        <div class="col-6 d-flex" style="align-items: flex-end">
          <v-select
            v-model="mode"
            :items="['R$', '%']"
            :disabled="!!modo_unico_ativos"
            style="max-width: 50px"
            @change="$forceUpdate"
          ></v-select>
          <v-currency-field
            v-if="show"
            ref="edit-valor"
            v-model="valor"
            :allow-negative="false"
          />
        </div>
        <div
          v-if="
            actualClass.percent && actualClass.percent > actualClass.alocado
          "
          class="col-12 pt-0 d-flex"
        >
          <div style="width: 50%">
            <v-btn x-small @click="adjustByGeneral">
              Disponível: {{ toPercent(100 * (plLivre / plTotal)) }}
            </v-btn>
          </div>
          <v-btn x-small @click="adjustByClass">
            Ainda disponível na {{ showSubclass ? 'subclasse' : 'classe' }}:
            {{ toPercent(actualClass.percent - actualClass.alocado) }}
          </v-btn>
        </div>
        <div v-if="plTotal && !hideAlerts" class="col-12 pt-0 d-flex">
          <div style="width: 50%">
            <small class="text-secondary">
              P/L Simulação: {{ toMoney(plTotal) }}
            </small>
          </div>
          <small class="text-secondary">
            P/L Não alocado: {{ toMoney(plLivre) }}
          </small>
        </div>
        <div v-if="showAlets && !hideAlerts" class="col-12 pt-0">
          <div
            style="
              padding: 7px;
              border-radius: 12px;
              font-weight: normal;
              background: #fff9c4 !important;
            "
            class="elevation-1 text-dark"
          >
            <p class="mb-0">
              <small v-if="alertJanelaTempo">
                - Este ativo não supre a restrição de janela de tempo. Caso não
                aumente a janela de tempo, ele irá ser desconsiderado na
                análise.
              </small>
            </p>
            <p class="mb-0">
              <small v-if="alertSaldoPerm">
                - Valor informado é menor que o saldo de permanência do ativo
                ({{ toMoney(ativo.saldo_permanencia) }}).
              </small>
            </p>
            <p class="mb-0">
              <small v-if="alertAplMin">
                - Valor informado é menor que a aplicação minima do ativo ({{
                  toMoney(aplMin)
                }}).
              </small>
            </p>
            <p class="mb-0">
              <small v-if="alertQualificado">
                - Este ativo está disponível somente para clientes
                <i> qualificados. </i> O cliente selecionado não se encaixa na
                restrição.
              </small>
            </p>
          </div>
        </div>
        <div
          v-if="
            ['Operações Estruturadas', 'Renda Fixa'].includes(ativo.tipo) &&
            !hideAlerts
          "
          class="col-6"
        >
          <v-text-field
            v-model="ativo.data_carencia"
            v-mask="maskData"
            :label="
              ativo.tipo === 'Operações Estruturadas'
                ? 'Data de observação'
                : 'Data de carência'
            "
            persistent-hint
            prepend-inner-icon="event"
          ></v-text-field>
        </div>
        <div
          v-if="
            ['Operações Estruturadas', 'Renda Fixa'].includes(ativo.tipo) &&
            !hideAlerts
          "
          class="col-6"
        >
          <v-select v-model="ativo.rating" label="Rating" :items="RATINGS" />
        </div>
        <div v-if="ativo.tipo === 'Renda Fixa' && !hideAlerts" class="col-6">
          <v-checkbox v-model="ativo.carencia_diaria" label="Carência diária" />
        </div>

        <div class="col-6">
          <v-select
            v-model="ativo.recomendacao"
            :items="recomendacaoOptions"
            item-text="text"
            item-value="value"
            label="Recomendação"
            clearable
          />
        </div>

        <div class="col-6">
          <v-text-field
            v-model="ativo.setor"
            label="Setor"
            clearable
          />
        </div>

        <div class="col-12 simulador-editar-ativo__tags">
          <div class="az-text-small mb-2"> Tags </div>

          <ClientTags
            :tags="ativo.tags"
            :loading="loading"
            canEdit
            showTextNoTag
            @add-tag="handleAddTag"
            @remove-tag="handleRemoveTag"
          />
        </div>

        <div class="col-12 simulador-editar-ativo__description">
          <div class="az-text-small mb-2"> Comentário </div>
          <input-by-type
            v-model="ativo.comentario"
            type="textarea"
            outlined
            hide-details
            class="new-ux"
          />
        </div>
      </div>
    </v-form>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Editar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass">
.simulador-editar-ativo
  &__description
    background: #F5F5F5
    padding: 20px
    border-radius: 8px
    color: #5E5E5E
</style>
